import { render, staticRenderFns } from "./top10.vue?vue&type=template&id=722f2cd6&"
import script from "./top10.vue?vue&type=script&lang=ts&"
export * from "./top10.vue?vue&type=script&lang=ts&"
import style0 from "./top10.vue?vue&type=style&index=0&id=722f2cd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports